// extracted by mini-css-extract-plugin
export default {"label":"styles_label__ZFSkK","green":"styles_green__hrk4n","grey":"styles_grey__5Wi-R","orange":"styles_orange__l2HgW","red":"styles_red__2LiN4","blue":"styles_blue__aY5Mh"};